import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useUiStore } from "@/stores/ui.store";
import { useAuthStore } from "@/stores/auth.store";
import {
  MAIN_BG,
  SIDEBAR_WIDTH_COLLAPSED,
  SIDEBAR_WIDTH_EXPANDED,
} from "@/lib/constants";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { CommandPalette } from "./CommandPalette";
import { IMPERSONATION_BANNER_HEIGHT } from "@/components/auth/ImpersonationBanner";
import { CallTimerBanner } from "@/components/calls/CallTimerBanner";
import { FundingImportDock } from "@/components/companies/funding/FundingImportDock";

export function AppLayout() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const impersonating = useAuthStore((s) => !!s.user?.impersonated_by);
  const offset = collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;
  const topOffset = impersonating ? IMPERSONATION_BANNER_HEIGHT : 0;

  const [paletteOpen, setPaletteOpen] = useState(false);

  // Cmd+K (or Ctrl+K on Windows/Linux) toggles the global search palette.
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((o) => !o);
      }
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div
      className="min-h-screen text-slate-900"
      style={{ backgroundColor: MAIN_BG, paddingTop: topOffset }}
    >
      <Sidebar onOpenSearch={() => setPaletteOpen(true)} />
      <div
        className="flex flex-col transition-[margin] duration-200"
        style={{
          marginLeft: offset,
          minHeight: `calc(100vh - ${topOffset}px)`,
        }}
      >
        <CallTimerBanner />
        <Header />
        <main className="flex-1 px-8 py-8">
          <Outlet />
        </main>
      </div>
      <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
      {/* A funding import continuing in the background, on every page. */}
      <FundingImportDock />
    </div>
  );
}
